<template>
  <div class="wrap" id="wrap" ref="cansImg">
    <!-- <canvas v-if="showQr" ref="qrcode"></canvas> -->
    <canvas ref="qrcode"></canvas>
  </div>
</template>

<script>
import QRious from 'qrious';

export default {
  name: 'qrcode',
  data() {
    return {
      showQr: true
    };
  },
  props: {
    /**
     * The options for the QR code generator.
     * {@link https://github.com/neocotic/qrious#api}
     */
    options: Object,

    /**
     * The tag of the component root element.
     */
    tag: {
      type: String,
      default: 'canvas'
    },

    /**
     * The value of the QR code.
     */
    value: {
      type: null,
      default: ''
    }
  },
  watch: {
    /**
     * Update QR code when value change.
     */
    value() {
      this.generate();
    },

    /**
     * Update QR code when options change.
     */
    options() {
      this.generate();
    }
  },
  methods: {
    /**
     * Generate QR code.
     */
    generate() {
      if (this.$el) {
        new QRious({
          element: this.$refs.qrcode,
          value: String(this.value),
          background: 'white',
          // foreground: '#FFAE7E',
          ...this.options
        });
        console.log('this.$refs0000000000000:', this.$refs);
        // let that = this;
        window.html2canvas(this.$refs.qrcode).then(function(canvas) {
          const img = window.Canvas2Image.convertToPNG(canvas, 320, 320);
          console.log('img1111111111111111111:', img);
          console.log('document:', document);
          var detail = document.getElementById('wrap');
          console.log('detail8888888888888888888888:', detail);
          // detail['0'] = img;
          detail.innerHTML = '';
          // this.showQr = false;
          detail.appendChild(img);
          /*  const base64 = img.src.split(',')[1];
          that.$refs.imgCanvas.src = base64;
          console.log('that.$refs.imgCanvas.src:', that.$refs.imgCanvas.src);
          that.$refs.imgCanvas.width = '80px';
          that.$refs.imgCanvas.height = '80px'; */
          /* this.$refs.cansImg.appendChild(img);
          $(img)
            .css({
              width: '80px',
              height: '80px'
            })
            .addClass('f-full'); */
        });
      }
    }
  },
  mounted() {
    this.generate();
  }
};
</script>
